import type { SourceGameMeta } from '../common/SourceGameHeader';
import type {
  OpeningSearchResult,
  PlayerSearchResult,
} from '../games/browse/gamesApi';
import { replayHubPath } from './replayUrl';

/** Router location.state when opening a game in the replay trainer. */
export type ReplayLocationState = SourceGameMeta & {
  /** Path (with query) to navigate to when the user exits replay. */
  returnTo?: string;
  /** Restore the Games page player detail when returning to `/games`. */
  selectedPlayer?: PlayerSearchResult;
  /** Restore the Games page opening detail when returning to `/games`. */
  selectedOpening?: OpeningSearchResult;
};

export const parseReplayLocationState = (
  state: unknown,
): ReplayLocationState | null => {
  if (!state || typeof state !== 'object') {
    return null;
  }
  return state as ReplayLocationState;
};

export const replayReturnPath = (state: ReplayLocationState | null): string =>
  state?.returnTo?.trim() || replayHubPath();

export const replaySourceMetaFromState = (
  state: ReplayLocationState | null,
): SourceGameMeta | null => {
  if (!state) {
    return null;
  }
  const {
    white,
    black,
    whiteElo,
    blackElo,
    timeControl,
    timeClass,
    date,
    result,
    eco,
    opening,
    event,
    openingSans,
  } = state;
  return {
    white,
    black,
    whiteElo,
    blackElo,
    timeControl,
    timeClass,
    date,
    result,
    eco,
    opening,
    event,
    openingSans,
  };
};

export const buildReplayLocationState = (
  meta: SourceGameMeta,
  options: {
    returnTo: string;
    selectedPlayer?: PlayerSearchResult;
    selectedOpening?: OpeningSearchResult;
  },
): ReplayLocationState => ({
  ...meta,
  returnTo: options.returnTo,
  ...(options.selectedPlayer ? { selectedPlayer: options.selectedPlayer } : {}),
  ...(options.selectedOpening ? { selectedOpening: options.selectedOpening } : {}),
});
